import { find, without } from 'lodash';

import { PUSH_TOAST, REMOVE_TOAST } from './actions';
import { findByToastIdentity } from '../util';

import Logger from '../../utils/Logger';
import { toastIdentity } from '../../definitions/ToastConstants';

let { id: module_id } = module;
const logger = new Logger(module_id);

const initialState = {
  data: [],
};

const addToast = (toast, toasts) => {
  // basically work as a set, so don't add duplicates
  if (find(toasts, (t) => toast.key === t.key)) {
    return toasts;
  }
  return [...toasts, toast];
};

const removeNotificationByIdentifier = (identifier, toasts) => {
  if (!identifier) {
    logger.error('Could not find toast by identifier', identifier);
    return toasts;
  }
  let toast = findByToastIdentity(toasts, identifier);
  return without(toasts, toast);
};

const toasts = (state = initialState, action) => {
  let { type, payload } = action;
  switch (type) {
    case PUSH_TOAST: {
      return {
        ...state,
        data: addToast(payload.toast, state.data),
      };
    }
    case REMOVE_TOAST: {
      return {
        ...state,
        data: removeNotificationByIdentifier(
          payload[toastIdentity],
          state.data
        ),
      };
    }
    default:
      return state;
  }
};

export { toasts };
